<div class="item-container">
    <div class="item-header">
        <h5 class="text-center" *ngIf="dialogData.modalType!='edit_template'">{{"COMMON.ADD" | translate}} Shifts</h5>
        <h5 class="text-center" *ngIf="isEditTemplate">Edit Template</h5>
        <div class="edit-icons" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="tab-box mt-4 mb-4 flex-wrap gap-2" *ngIf="!isEditTemplate">
        <div class="d-flex justify-content-center align-items-center tab-item " id="i-4" *ngFor="let item of tabsArr"
            (click)="onCurrentTab(item.value)" [ngClass]="currentTab == item.value ? 'active-tab' : ''">
            <div class="tab-txt ps-1 ps-sm-2">{{item.name}}</div>
        </div>
    </div>
    <div class="item-content shift-container">
        <div class="">
            <div *ngIf="currentTab == 'shift_details'">
                <form action="" [formGroup]="addForm">
                    <div>
                        <div *ngIf="isParameterAllowed('multiple_dates')">
                            <label for="" class="mb-0"> Select Date</label>
                            <div class="add-shift" formArrayName="date">
                                <mat-chip-grid #chipGrid aria-label="">
                                    <mat-chip-row *ngFor="let item of shiftDatesFb.controls;let i=index"
                                        [formGroupName]="i" (removed)="remove(item.get('date')?.value,calendar)"
                                        [editable]="false">
                                        <div class="text-semibold">{{item.get('display_dt')?.value}}</div>
                                        <button matChipRemove [attr.aria-label]="'remove' + item">
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip-row>
                                    <input placeholder="" [matChipInputFor]="chipGrid" disabled
                                        class="date-b form-control" />
                                    <button mat-icon-button [matMenuTriggerFor]="appMenu">
                                        <mat-icon>calendar_today</mat-icon></button>
                                    <mat-menu #appMenu="matMenu">
                                        <div (click)="$event.stopPropagation()" class="habit-tracker mb-3">
                                            <mat-calendar #calendar (selectedChange)="daySelected($event,calendar)"
                                                [dateClass]="dateClass"></mat-calendar>
                                        </div>
                                    </mat-menu>
                                </mat-chip-grid>
                            </div>
                            <!-- if all day is selected then no need to have start time and end time -->
                            <div *ngIf="addForm.get('all_day')?.value==false" formArrayName="date">
                                <div *ngFor="let item of shiftDatesFb.controls;let i=index" [formGroupName]="i"
                                    class="d-flex align-items-center mt-3 date-box justify-content-between">
                                    <div class="d-flex align-items-center">
                                        <div class="me-3">{{item.get('display_dt')?.value}}</div>
                                        <div class="me-3">
                                            <input [ngxTimepicker]="picker" class="form-control num-b me-3"
                                                [format]="24" placeholder="Select Start Time" formControlName="s_sti">
                                            <ngx-material-timepicker #picker
                                                (closed)="onTimeChanged()"></ngx-material-timepicker>
                                            <mat-error
                                                *ngIf="item.get('s_sti')?.hasError('required') && item.get('s_sti')?.touched">
                                                {{"COMMON.THR"|translate}}</mat-error>
                                        </div>
                                        <div class="me-3">
                                            <input [ngxTimepicker]="epicker" class="form-control num-b me-3"
                                                [format]="24" placeholder="Select End Time" formControlName="e_eti">
                                            <ngx-material-timepicker #epicker
                                                (closed)="onTimeChanged()"></ngx-material-timepicker>
                                            <mat-error
                                                *ngIf="item.get('e_eti')?.hasError('required') && item.get('e_eti')?.touched">
                                                {{"COMMON.THR"|translate}}</mat-error>
                                        </div>
                                    </div>
                                    <div class="action-icon  del-icon delete-img ms-2 flex-shrink-0"
                                        (click)="remove(item.get('date')?.value,calendar)">
                                        <i class="material-icons">close</i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isParameterAllowed('single_date')">
                            <label for=""> Select Date</label>
                            <div class="in-box">
                                <input class="form-control" [matDatepicker]="eDate" placeholder="Select Date"
                                    formControlName="st_dt" />
                                <mat-datepicker-toggle matIconSuffix [for]="eDate"></mat-datepicker-toggle>
                                <mat-datepicker #eDate></mat-datepicker>
                            </div>
                            <mat-error *ngIf="isControlHasError('st_dt','required')">
                                {{"COMMON.THR"|translate}}</mat-error>
                        </div>
                        <div class="d-flex align-items-center flex-wrap">
                            <div class="mt-3 me-4">
                                <mat-slide-toggle color="primary" class="mb-0 slide-1"
                                    (change)="onAllDayChanged($event)" formControlName="all_day">
                                </mat-slide-toggle>
                                <label for="" class="mb-0">All day</label>
                            </div>
                            <div class="mt-3 me-4" *ngIf="isParameterAllowed('instant_hire')">
                                <mat-slide-toggle color="primary" class="mb-0 slide-1"
                                    formControlName="ins_h"></mat-slide-toggle>
                                <label for="" class="mb-0">Instant Hire</label>
                            </div>
                            <div *ngIf="!isNoRepeat">
                                <div class="d-flex align-items-center mt-3 cursor-pointer" (click)="onScheduleShift()"
                                    *ngIf="!repeatText && !isEditTemplate">
                                    <i class="material-icons primary-color-icon me-2">repeat</i>
                                    <div class="primary-color text-medium">Does not repeat</div>
                                </div>
                            </div>

                        </div>
                        <div class="primary-color text-bold mt-3 cursor-pointer" (click)="onScheduleShift()"
                            *ngIf="repeatText">{{repeatText}}</div>
                        <div class="row"
                            *ngIf="addForm.get('all_day')?.value==false && isParameterAllowed('single_date')">
                            <div class="col-md-6">
                                <label for="" class="mt-3 mb-1">Start Time</label>
                                <input [ngxTimepicker]="picker" class="form-control num-b me-3" [format]="24"
                                    placeholder="Select Start Time" formControlName="st_ti">
                                <ngx-material-timepicker #picker></ngx-material-timepicker>
                                <mat-error *ngIf="isControlHasError('st_ti','required')">
                                    {{"COMMON.THR"|translate}}</mat-error>
                            </div>
                            <div class="col-md-6">
                                <label for="" class="mt-3 mb-1">End Time</label>
                                <input [ngxTimepicker]="epicker" class="form-control num-b me-3" [format]="24"
                                    placeholder="Select End Time" formControlName="ed_ti">
                                <ngx-material-timepicker #epicker></ngx-material-timepicker>
                                <mat-error *ngIf="isControlHasError('ed_ti','required')">
                                    {{"COMMON.THR"|translate}}</mat-error>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mt-3">
                                <div>
                                    <label for="">Job Title</label>
                                    <input type="text" class="form-control" placeholder="Write Job Title"
                                        value="Relief Chef" formControlName="j_n">
                                    <mat-error *ngIf="isControlHasError('j_n','required')">
                                        {{"COMMON.THR"|translate}}</mat-error>
                                </div>
                            </div>
                            <div class="col-md-6 mt-3">
                                <div>
                                    <label for="">Quantity</label>
                                    <input type="number" placeholder="Define Quantity" class="form-control"
                                        formControlName="qty">
                                    <mat-error
                                        *ngIf="isControlHasError('qty','required')">{{"COMMON.THR"|translate}}</mat-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="mt-3">
                                    <label for="">Category</label>
                                    <mat-select class="form-control" placeholder="Select Category" formControlName="j_c"
                                        (selectionChange)="onSelectCategory($event)">
                                        <mat-option *ngFor="let item of categoryArr"
                                            [value]="item.j_c">{{item.j_c}}</mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="isControlHasError('j_c','required')">{{"COMMON.THR"|translate}}</mat-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="mt-3">
                                    <label for="">Sub Category</label>
                                    <mat-select class="form-control" placeholder="Select Sub Category"
                                        formControlName="j_sc" (selectionChange)="onSelectSubCat($event)">
                                        <mat-option *ngFor="let item of subCategoryArr"
                                            [value]="item.j_sc">{{item.j_sc}}</mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="isControlHasError('j_sc','required')">{{"COMMON.THR"|translate}}</mat-error>
                                </div>
                            </div>
                        </div>
                        <div class="mt-3" *ngIf="isParameterAllowed('shift_type')">
                            <label for="">Shift Type</label>
                            <mat-radio-group class=" d-flex rd-box" formControlName="user_type">
                                <div class="d-flex">
                                    <mat-radio-button class="" value="2"></mat-radio-button>
                                    <div class="radio-title l-h">Recruiter</div>
                                </div>
                                <div class="d-flex ms-4 rd-l">
                                    <mat-radio-button class="" value="0"></mat-radio-button>
                                    <div class="radio-title  l-h">Freelancer</div>
                                </div>
                            </mat-radio-group>
                            <mat-error
                                *ngIf="isControlHasError('user_type','required')">{{"COMMON.THR"|translate}}</mat-error>
                        </div>
                        <div class="mb-3"
                            *ngIf="(isParameterAllowed('shift_type') && addForm.get('user_type')?.value==2) || (dialogData?.shift_data?.u_t == 2 && filterRecArr.length != 0 )">
                            <div class="mt-3 me-4">
                                <mat-slide-toggle color="primary" class="mb-0 slide-1"
                                    formControlName="s_rec"></mat-slide-toggle>
                                <label for="" class="mb-0">Send to all Recruiters</label>
                            </div>
                            <div *ngIf="addForm.get('s_rec')?.value==false">
                                <label for="" class="mb-0">Select Recruiter</label>
                                <div class="mt-1">
                                    <ng-select [items]="filterRecArr" bindLabel="company_name"
                                        [searchFn]="customSearchFn" [multiple]="true" placeholder="Select Recruiter"
                                        [editableSearchTerm]="true" bindValue="company_id" [closeOnSelect]="false"
                                        groupBy="e" [selectableGroup]="true" formControlName="rec"
                                        [selectableGroupAsModel]="false">
                                        <ng-template ng-optgroup-tmp let-item="item" let-item$="item$"
                                            let-index="index">
                                            <!-- as we are using this inside formGroup don't forget to add standalone true options as true -->
                                            <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                                                [ngModelOptions]="{standalone: true}" /> Select All
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                            <div class="d-flex align-items-center em-box">
                                                <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                                                    [ngModelOptions]="{standalone: true}" class="me-2" />
                                                <div> {{ item.company_name }} </div>
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="d-flex mt-3 me-4 flex-wrap">
                                <label class="me-3" for="">Select Type</label>
                                <!-- formcontrolName rec_emp_typ is used at two places in the component please check before making changes -->
                                <mat-radio-group class=" d-flex flex-wrap rd-box" formControlName="rec_emp_typ">
                                    <div class="d-flex me-3">
                                        <mat-radio-button class="" value="0"></mat-radio-button>
                                        <div class="radio-title l-h">Send to All Employees </div>
                                    </div>
                                    <div class="d-flex me-2">
                                        <mat-radio-button class="" value="1"></mat-radio-button>
                                        <div class="radio-title l-h">Send to Favorites</div>
                                    </div>
                                </mat-radio-group>
                            </div>
                        </div>
                        <!-- <div class="mt-3" *ngIf="dialogData?.shift_data?.u_t == 2">
                            <label for="" class="mb-0">Select Recruiter</label>
                            <div class="mt-1">
                                <ng-select [items]="filterRecArr" bindLabel="company_name"
                                    [searchFn]="customSearchFn" [multiple]="true" placeholder="Select Recruiter"
                                    [editableSearchTerm]="true" bindValue="company_id" [closeOnSelect]="false"
                                    groupBy="e" [selectableGroup]="true" formControlName="rec"
                                    [selectableGroupAsModel]="false">
                                    <ng-template ng-optgroup-tmp let-item="item" let-item$="item$"
                                        let-index="index">
                                        <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                                            [ngModelOptions]="{standalone: true}" /> Select All
                                    </ng-template>
                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                        <div class="d-flex align-items-center em-box">
                                            <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                                                [ngModelOptions]="{standalone: true}" class="me-2" />
                                            <div> {{ item.company_name }} </div>
                                        </div>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div> -->
                        <div class="mt-3"
                            *ngIf="isParameterAllowed('employee_shift_type') && userType !== 'admin' && adminType !== 'admin' ">
                            <label for="">Shift Type (Employee)</label>
                            <!-- formcontrolName rec_emp_typ is used at two places in the component please check before making changes for recruiter and favorites -->
                            <mat-radio-group class="d-flex flex-wrap rd-box" formControlName="own_emp_typ">
                                <div class="d-flex me-3">
                                    <mat-radio-button class="" value="2"></mat-radio-button>
                                    <div class="radio-title l-h">Send to All </div>
                                </div>
                                <div class="d-flex me-2">
                                    <mat-radio-button class="" value="1"></mat-radio-button>
                                    <div class="radio-title l-h">Assign to specific</div>
                                </div>
                                <div class="d-flex rd-l">
                                    <mat-radio-button class="" value="0"></mat-radio-button>
                                    <div class="radio-title  l-h">Offer to specific </div>
                                </div>
                            </mat-radio-group>
                            <div class="mt-3"><span class="text-bold">Note:</span>
                                <span class="grey-2 small-text"> By ‘all employees,’ we are referring to those within
                                    the selected category and subcategory.</span>
                            </div>
                        </div>
                        <div class="mt-3" *ngIf="isParameterAllowed('send_to_fav')">
                            <div class="d-flex align-items-center flex-wrap">
                                <label for="" class="mb-0 me-3">Select Employee Type</label>
                                <mat-radio-group (change)="getEmpValue($event)" class=" d-flex rd-box"
                                    formControlName="fav_emp_typ">
                                    <div class="d-flex">
                                        <mat-radio-button class="" value="0"></mat-radio-button>
                                        <div class="radio-title l-h">Offer to Favourties </div>
                                    </div>
                                    <div class="d-flex ms-4 rd-l">
                                        <mat-radio-button class="" value="1"></mat-radio-button>
                                        <div class="radio-title  l-h">Assign to Favourties </div>
                                    </div>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="mt-3" *ngIf="userType=='recruiter' || adminType=='admin'">
                            <label for="">Company</label>
                            <mat-select class="form-control" placeholder="Select Company" formControlName="co_i"
                                (selectionChange)="onSelectCompany($event)">
                                <mat-option *ngFor="let item of companyArr"
                                    [value]="item.co_i">{{item.company_name}}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <div class="mt-3" *ngIf="(isParameterAllowed('select_emp') && addForm.get('rec_emp_typ')?.value!='0') 
                        || (isParameterAllowed('select_emp') && addForm.get('own_emp_typ')?.value!='2') 
                        || (isParameterAllowed('send_to_fav') && addForm.get('fav_emp_typ')?.value=='1')
                        ||  (dialogData.modalType=='edit'||dialogData.modalType=='open_shift')
                        ||  (dialogData.modalType=='edit'||dialogData.viewType=='user'||dialogData.viewType=='c_user') 
                        || userType === 'recruiter' || userType === 'admin' || adminType === 'admin'">

                        <label for="">Employee</label>
                        <div class="mt-1">
                            <ng-select (scrollToEnd)="onScrollBottom()" [items]="filterEmployeeArr" bindLabel="fullName"
                                [searchFn]="customSearchFn" bindValue="em_i" [multiple]="true"
                                placeholder="Select Employee" [editableSearchTerm]="true" formControlName="emp"
                                [closeOnSelect]="false" groupBy="e" [selectableGroup]="true"
                                [selectableGroupAsModel]="false">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                                    <!-- as we are using this inside formGroup don't forget to add standalone true options as true -->
                                    <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                                        [ngModelOptions]="{standalone: true}" />
                                    Select All
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <div class="d-flex align-items-center em-box">
                                        <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                                            [ngModelOptions]="{standalone: true}" class="me-2" />
                                        <i class="material-icons me-2 star" *ngIf="(item.is_f==1)">star_rate</i>
                                        <div class="u-img me-2" [appBackgroundImg]="item.profile_picture"></div>
                                        <div> {{ item.first_name }} {{ item.last_name }}</div>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div class="mt-3">
                        <label for="">Location</label>
                        <div class="d-flex">
                            <div class="me-3 flex-grow-1 calc-maxwidth-add add-shift">
                                <mat-select class="form-control" placeholder="Select Location" formControlName="add"
                                    (selectionChange)="onChangeAddress($event)">
                                    <mat-option *ngFor="let item of locArr" [value]="item.add">{{item.add}}</mat-option>
                                </mat-select>
                            </div>
                            <button mat-raised-button color="primary" class="no-sh-btn" type="submit"
                                (click)="onAddLocation()">
                                <i class="material-icons me-2 text-white">map</i>{{"COMMON.ADD" | translate}}
                                Locations
                            </button>
                        </div>
                        <mat-error *ngIf="isControlHasError('add','required')"> {{"COMMON.THR"|translate}}</mat-error>
                    </div>
                    <!-- <div class="col-md-6 mt-3 ">
                        <div>
                            <label for="">Experience (In year)</label>
                            <input type="number" placeholder="Define Year" class="form-control"
                                formControlName="experience">
                        </div>
                    </div> -->
                    <div class="mt-3">
                        <label for="">Notes</label>
                        <textarea name="" id="" class="form-control ps-2" formControlName="notes"></textarea>
                    </div>
                    <div class="mt-3">
                        <label for="">Dress Code</label>
                        <mat-select class="form-control" placeholder="Select Dress Code" formControlName="dr_c">
                            <mat-option *ngFor="let item of dressCodeArr" [value]="item.dr_c">{{item.dr_c}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="isControlHasError('dr_c','required')">{{"COMMON.THR"|translate}}</mat-error>
                    </div>
                    <div class="row" *ngIf="(dialogData.modalType == 'open_shift' || dialogData.modalType == 'edit')">
                        <div class="col-md-6 mt-3">
                            <label for="">Shift Status</label>
                            <mat-select class="form-control" placeholder="Select Shift Status" formControlName="pause">
                                <mat-option *ngFor="let item of shiftStatus" [value]="item.value">{{item.name
                                    }}</mat-option>
                            </mat-select>
                            <div class="mt-1"><span class="text-bold">Note:</span>
                                <span class="grey-2 small-text"> Changing the shift's status will impact all employees
                                    assigned to it.</span>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <label for="">Shift Tasks</label>
                        <div formArrayName="shift_task">
                            <div class="row close-box" *ngFor="let item of shiftTasks.controls; let i = index"
                                [formGroupName]="i">
                                <div class=" col-sm-7 col-md-7 mb-3 ">
                                    <div class="d-flex align-items-center">
                                        <input formControlName="task" placeholder="Enter Task" class="form-control">
                                        <div class="action-icon  del-icon delete-img ms-2" (click)="removeTasks(i)">
                                            <i class="material-icons">close</i>
                                        </div>
                                    </div>
                                    <mat-error
                                        *ngIf="item.get('task')?.hasError('required') && item.get('task')?.touched">
                                        {{"COMMON.THR"|translate}}</mat-error>
                                </div>
                            </div>
                        </div>
                        <div class="i-box cursor-pointer mt-3 mt-sm-0" (click)="addTasks()">
                            <span><i class="fas fa-plus"></i> {{"COMMON.ADD" | translate}} Tasks </span>
                        </div>
                    </div>
                    <div class="mt-3">
                        <label for="">Shift Questions</label>
                        <div formArrayName="que">
                            <div class="row close-box" *ngFor="let item of shiftQue.controls; let i = index"
                                [formGroupName]="i">
                                <div class=" col-sm-7 col-md-7 mb-3 ">
                                    <div class="d-flex align-items-center">
                                        <input formControlName="question" placeholder="Enter Question"
                                            class="form-control">
                                        <div class="action-icon  del-icon delete-img ms-2" (click)="removeQue(i)">
                                            <i class="material-icons">close</i>
                                        </div>
                                    </div>
                                    <mat-error
                                        *ngIf="item.get('question')?.hasError('required') && item.get('question')?.touched">
                                        {{"COMMON.THR"|translate}}</mat-error>
                                </div>
                            </div>
                        </div>
                        <div class="i-box cursor-pointer mt-3 mt-sm-0" (click)="addQuestions()">
                            <span><i class="fas fa-plus"></i> {{"COMMON.ADD" | translate}} Questions </span>
                        </div>
                    </div>
                </form>
                <div>
                    <mat-error *ngIf="errorMsg">{{errorMsg}}</mat-error>
                </div>
            </div>
            <div *ngIf="currentTab == 'activity'">
                <div class="activity-cont">
                    <div class="d-flex flex-column mb-20 pse-25">
                        <mat-expansion-panel *ngFor="let item of activityArr; let i = index" class="height-55"
                            (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header class="me-2">
                                <mat-panel-title>
                                    <div class="pro-pic me-2">
                                        <div class="profile-img me-2" [appBackgroundImg]="checkUrl(item.actor_img)">
                                        </div>
                                    </div>
                                    <div class="log-content">
                                        <div class="d-flex gap-2 flex-wrap line-normal">
                                            {{item.actor_name}}
                                            <div class=" a-pri">{{item.affect_type}}</div>
                                        </div>
                                    </div>
                                </mat-panel-title>
                                <mat-panel-description>
                                    <!-- <i class="material-icons cursor-pointer" (click)="onEdit(dataDetails,'normal')">edit</i> -->
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div class="inner-container d-flex flex-column gap-2">
                                <div class="small-text">{{item.j_n}}</div>
                                <div class="small-text">{{item.j_c}}({{item.j_sc}})</div>
                                <div class="small-text">{{item.c_at}}</div>
                                <div class="small-text">{{item.add}}</div>
                            </div>
                        </mat-expansion-panel>
                    </div>
                </div>
            </div>
            <div *ngIf="currentTab == 'shift_request'">
                <div class="d-flex justify-content-center align-items-end"
                    *ngIf="dataSource.data.length > 0 && !isSpinnerLoading2">
                    <button mat-raised-button color="primary" class="auth-form-btn ms-auto auto-rej" type="submit"
                        (click)="acceptAll()"> Accept All</button>
                    <button mat-raised-button color="primary" class="auth-form-btn ms-3 auto-rej" type="submit"
                        (click)="autoReject()"> Auto Reject</button>
                    <div class="ms-1"><i class="material-icons"
                            matTooltip="All the pending request will be rejected using the Auto Reject">info_outline</i>
                    </div>
                </div>
                <div class="table-container flex-grow-1 ">
                    <table class="" mat-table [dataSource]="dataSource" class="mat-elevation-z8"
                        *ngIf="dataSource.data.length!=0">
                        <ng-container matColumnDef="employee">
                            <th mat-header-cell *matHeaderCellDef> {{"COMMON.CANDIDATE"|translate}}</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="d-flex cursor-pointer" (click)="onViewEmployee(element.em_i)">
                                    <div class="profile-img me-2" [appBackgroundImg]="element.profile_picture"></div>
                                    <div class="">
                                        <div class="main-head">{{element.first_name}} {{element.last_name}}</div>
                                        <div class="sub-head">{{element.email}}</div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> {{"COMMON.STATUS"|translate}}</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-bold st-box  d-flex ">
                                    <span class="un-attend badge-c d-box"
                                        *ngIf="element.app==0">{{"Rejected"|translate}}</span>
                                    <span class="active badge-c d-box"
                                        *ngIf="element.app==1">{{"Accepted"|translate}}</span>
                                    <span class="pending badge-c d-box"
                                        *ngIf="element.app==2">{{"Pending"|translate}}</span>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>{{"COMMON.ACTION"|translate}}</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="d-flex">
                                    <div class="status-box accept me-2" matTooltip="{{'BUTTON.ACCEPT' | translate}}"
                                        [ngClass]="{'opacity': element.app==1}"
                                        (click)="onConfirmationModal(element,1)">
                                        <img src="assets/images/icons/tick_correct.svg" class="img-fluid" alt="">
                                    </div>
                                    <div class="status-box reject " matTooltip="{{'BUTTON.REJECT' | translate}}"
                                        [ngClass]="{'opacity': element.app==0}"
                                        (click)="onConfirmationModal(element,0)">
                                        <img src="assets/images/icons/cancel.svg" class="img-fluid" alt="">
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="more">
                            <th mat-header-cell *matHeaderCellDef> {{"COMMON.MORE"|translate}}</th>
                            <td mat-cell *matCellDef="let element">
                                <i class="material-icons cursor-pointer more-ic"
                                    [matMenuTriggerFor]="menu">more_vert</i>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item color="primary" (click)="onViewPastShift(element)">
                                        <mat-icon class="kt-margin-r-0">remove_red_eye</mat-icon>
                                        <span>View Past Shift</span>
                                    </button>
                                    <button mat-menu-item color="primary" (click)="onViewQuestion(element)"
                                        *ngIf="element.ans==1">
                                        <mat-icon class="kt-margin-r-0">remove_red_eye</mat-icon>
                                        <span>View Question</span>
                                    </button>
                                </mat-menu>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <div class="mat-table__message" *ngIf="dataSource.data.length==0 && !isSpinnerLoading2">
                        <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
                    </div>
                </div>
                <div class="mat-table__message position-relative" *ngIf="isSpinnerLoading2">
                    <div class="custom-loader"> </div>
                </div>
                <div class="pagination-cont" *ngIf="dataSource.data.length!=0 && !isSpinnerLoading2">
                    <div class="show-item"> {{"COMMON.SIP" | translate}}
                        <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event,'shiftREquest')"
                            [(ngModel)]="objData.shiftREquest.itemsPerPage">
                            <option [value]="item" *ngFor="let item of pageSizeOptions">{{ item }} </option>
                        </select>
                    </div>
                    <div class="page-c">
                        <ngb-pagination [collectionSize]="objData.shiftREquest.count"
                            [(page)]="objData.shiftREquest.currentPage" [pageSize]="objData.shiftREquest.itemsPerPage"
                            [maxSize]="objData.shiftREquest.maxPaginationSize"
                            (pageChange)="onPageChange($event,'shiftREquest')"></ngb-pagination>
                    </div>
                </div>

                <!-- <div class="pagination-cont" *ngIf="dataSourceShiftSent.data.length!=0">
                    <div class="show-item">{{"COMMON.SIP" | translate}}
                        <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event, 'shiftSent')"
                            [(ngModel)]="objData.shiftSent.itemsPerPage">
                            <option [value]="item" *ngFor="let item of pageSizeOptions">{{ item }}</option>
                        </select>
                    </div>
                    <div class="page-c">
                        <ngb-pagination [collectionSize]="objData.shiftSent.count" [(page)]="objData.shiftSent.currentPage"
                            [pageSize]="objData.shiftSent.itemsPerPage" [maxSize]="objData.shiftSent.maxPaginationSize"
                            (pageChange)="onPageChange($event, 'shiftSent')"></ngb-pagination>
                    </div>
                </div> -->
            </div>
            <div *ngIf="currentTab=='template'">
                <div class="tem-box " *ngFor="let item of templateArr" (click)="onSelectTemplate(item)">
                    <div class="d-flex justify-content-between">
                        <div *ngIf="item.all_day==0">{{item.st_ti}} - {{item.ed_ti}}</div>
                        <div *ngIf="item.all_day==1">All day</div>
                        <i class="material-icons cursor-pointer more-icon" [matMenuTriggerFor]="menu"
                            (click)="onMoreIconClick($event)">more_vert</i>
                        <mat-menu #menu="matMenu">
                            <!-- <button mat-menu-item color="primary" (click)="onEditTemplate(item)">
                                <mat-icon class="kt-margin-r-0">create</mat-icon>
                                <span>{{"COMMON.EDIT" | translate}}</span>
                            </button> -->
                            <button mat-menu-item color="primary" (click)="onDeleteTemplate(item)">
                                <mat-icon class="kt-margin-r-0">delete</mat-icon>
                                <span>{{"BUTTON.DELETE" | translate}}</span>
                            </button>
                        </mat-menu>
                    </div>
                    <div>{{item.j_c}}</div> 
                    <div>{{item.j_sc}}</div>
                </div>
                <div class="mat-table__message" *ngIf="templateArr.length==0">
                    <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
                </div>
            </div>
            <div *ngIf="currentTab=='shift_sent'">
                <div class="table-container flex-grow-1 ">
                    <table class="" mat-table [dataSource]="dataSourceShiftSent" class="mat-elevation-z8"
                        *ngIf="dataSourceShiftSent.data.length!=0 && !shiftSentCrone && !isSpinnerLoading">
                        <ng-container matColumnDef="employee">
                            <th mat-header-cell *matHeaderCellDef>{{"COMMON.CANDIDATE"|translate}}</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="d-flex cursor-pointer" (click)="onViewEmployee(element.em_i)">
                                    <div class="profile-img me-2" [appBackgroundImg]="element.profile_picture"></div>
                                    <div class="">
                                        <div class="main-head">{{element.first_name}} {{element.last_name}}</div>
                                        <div class="sub-head">{{element.email}}</div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef>
                                {{"COMMON.STATUS"|translate}}</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="text-bold st-box  d-flex ">
                                    <span class="un-attend   badge-c d-box"
                                        *ngIf="element.accept==0">{{"Rejected"|translate}}</span>
                                    <span class="active badge-c d-box"
                                        *ngIf="element.accept==1">{{"Applied"|translate}}</span>
                                    <span class="pending badge-c d-box"
                                        *ngIf="element.accept==2">{{"Pending"|translate}}</span>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsShiftSent"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsShiftSent;"></tr>
                    </table>
                    <div class="mat-table__message"
                        *ngIf="dataSourceShiftSent.data.length==0 && !shiftSentCrone && !isSpinnerLoading">
                        <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
                    </div>
                    <div class="mat-table__message position-relative" *ngIf="isSpinnerLoading">
                        <div class="custom-loader"> </div>
                    </div>
                    <div class="d-flex align-items-center flex-column justify-content-center"
                        *ngIf="shiftSentCrone && !isSpinnerLoading">
                        <img src="assets/images/gifs/waiting.gif" class="img-fluid" alt="">
                        <div class="w-title">Wait for few seconds. </div>
                        <div class="w-sub-title">Right now shifts are being sent to appropriate candidates!</div>
                    </div>
                </div>
                <div class="pagination-cont"
                    *ngIf="dataSourceShiftSent.data.length!=0 && !shiftSentCrone && !isSpinnerLoading">
                    <div class="show-item">{{"COMMON.SIP" | translate}}
                        <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event, 'shiftSent')"
                            [(ngModel)]="objData.shiftSent.itemsPerPage">
                            <option [value]="item" *ngFor="let item of pageSizeOptions">{{ item }}</option>
                        </select>
                    </div>
                    <div class="page-c">
                        <ngb-pagination [collectionSize]="objData.shiftSent.count"
                            [(page)]="objData.shiftSent.currentPage" [pageSize]="objData.shiftSent.itemsPerPage"
                            [maxSize]="objData.shiftSent.maxPaginationSize"
                            (pageChange)="onPageChange($event, 'shiftSent')"></ngb-pagination>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
    <div class="item-footer">
        <div class="d-flex align-items-center justify-content-center flex-wrap position-relative"
            *ngIf="currentTab=='shift_details'">
            <div class="action-btn  cursor-pointer" matTooltip="{{'BUTTON.DELETE' | translate}}"
                (click)="onDeleteShift()" *ngIf="(dialogData.modalType=='edit'||dialogData.modalType=='open_shift')">
                <img src="assets/images/icons/delete-icon.svg" class="img-fluid" alt="">
            </div>
            <button color="primary" class="btn btn-outline-primary  mt-2 mt-lg-3 me-3 " style="min-width: 180px;"
                type="submit" (click)="onSaveTemplate()"> {{isEditTemplate ? 'Save Template' : 'Save as template'}}
            </button>
            <button mat-raised-button color="primary" class="btn btn-primary mt-2 mt-lg-3  me-3" type="submit"
                *ngIf="!isEditTemplate" (click)="onSubmit()" [disabled]=" isSaving" style="min-width: 180px;">{{
                "BUTTON.SAVE" | translate }}
            </button>
        </div>
    </div>
</div>